import React from 'react';
import { SbInput, PlusOutlined } from 'uiCore';

/**
 * Reusable input with inline add button
 * Used by: OrgRegistryManagement, OrgTechContextSetup
 * Submits on Enter key or + icon click
 */
const InlineAddInput = ({ placeholder, value, onChange, onSubmit, autoFocus }) => (
  <SbInput
    autoFocus={autoFocus}
    placeholder={placeholder}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    onKeyDown={(e) => { if (e.key === 'Enter') onSubmit(); }}
    suffix={<PlusOutlined onClick={onSubmit} />}
  />
);

export default InlineAddInput;
